import { render, staticRenderFns } from "./after_sale_address_list.vue?vue&type=template&id=d76566fa&"
import script from "./after_sale_address_list.vue?vue&type=script&lang=js&"
export * from "./after_sale_address_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports